import { debounce } from 'lodash';
import { compose, lifecycle, mapProps } from 'recompose';
import moment from 'moment/moment';
import { connect } from 'react-redux';
import { Endpoints } from '../../../lib/LeanLinkService';
import * as holidaySelectors from '../../../entities/Holiday/selectors';
import { withFetch } from '../../../entities/Entity/containers';
import { defaultDisplayMonth } from './Calendar';

export default compose(
  withFetch({
    props: props => ({
      ...props,
      fetchHolidays: debounce((displayMonth) => {
        const endpoint = props.public ? Endpoints.public.resourceApi.holidays : Endpoints.holidays;
        props.fetch({
          url: endpoint({
            limit: 1000,
            filters: {
              from: moment(displayMonth).subtract(12, 'months').format('YYYY-MM-DD'),
              to: moment(displayMonth).add(12, 'months').format('YYYY-MM-DD'),
            },
          }),
        });
      }, 2000),
    }),
  }),
  lifecycle({
    componentWillMount() {
      this.props.fetchHolidays(defaultDisplayMonth(this.props));
    },
  }),
  mapProps(
    props => ({
      ...props,
      onChangeMonth: (displayMonth) => {
        if (props.onChangeMonth) {
          props.onChangeMonth(displayMonth);
        }
        props.fetchHolidays(displayMonth);
      },
    }),
  ),
  connect(state => ({
    holidays: holidaySelectors.holidays(state),
  })),
);
